<template>
    <div>
        <slot name="status" :mode="mode">
            <v-badge dot :color="state ? getColor(state) : null" inline left></v-badge>{{ state }}
        </slot>
    </div>
</template>

<script>
import getColor from '@/utils/getColor';
export default {
    name:"PStatus",
    props: {
        state: String
    },
    data() {
        return {
            mode: "dark"
        }
    },
    methods: {
        getColor
    }
}
</script>

<style>

</style>